export default __webpack_public_path__ + "static/media/home.b8fe35bb.svg";